'use strict';

/**
 *
 * @name: mozaic
 *
 */

import DirectiveTemplate from './nn-mozaic.directive.html';

function MozaicDirective($timeout, modulesAnalytics) {

  'ngInject';

  return {
    replace: true,
    restrict: 'EA',
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    transclude: true,
    link: function(scope, element) {

      scope.item = scope.content();
      scope.mocks = scope.item.jsonData;

      scope.analytics = modulesAnalytics;

      scope.mocks.instagramTumblr.forEach(function(item) {

        if (item.featured1) {

          scope.featured1 = item;
        }
        if (item.featured2) {

          scope.featured2 = item;
        }
        item.images.lr = item.images.lr.replace('http:', 'https:');
        item.images.mr = item.images.mr.replace('http:', 'https:');
      });

      scope.mocks.twitter.forEach(function(item) {

        item.text = item.text.replace(/http\S*\s?/g, '');
      });


      $timeout(function() {

        element.find('.cs-content ul li').each(function() {

          if ($(this).find('img').length) {

            var imgWidth = $(this).find('img').width();
            var imgHeight = $(this).find('img').height();

            if (imgWidth > imgHeight) {

              $(this).addClass('ori-landscape');
            } else if (imgWidth === imgHeight) {

              $(this).addClass('ori-square');
            } else {

              $(this).addClass('ori-portrait');
            }
          }
        });
      }, 555);

      scope.loaded = true;
    }
  };
}

export default MozaicDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-mozaic/nn-mozaic.directive.js